module.exports = __webpack_public_path__ + "img/analyser.8f2deb89.svg";